<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data: vm => ({
    [vm.$enums.InvitationStatus.Manual]: {
      icon: 'mdi-check',
      color: '#a7cba7',
      text: vm.$t('component.profile.administrationManagement.added.manually')
    },
    [vm.$enums.InvitationStatus.Accepted]: {
      icon: 'mdi-check',
      color: 'success',
      text: vm.$t('global.accepted')
    },
    [vm.$enums.InvitationStatus.Pending]: {
      icon: 'mdi-timer-sand',
      color: 'warning',
      text: vm.$t('global.pending')
    },
    [vm.$enums.InvitationStatus.Rejected]: {
      icon: 'mdi-close',
      color: 'error',
      text: vm.$t('global.rejected')
    }
  }),
  computed: {
    color() {
      return this[this.type].color
    },
    icon() {
      return this[this.type].icon
    },
    text() {
      return this[this.type].text
    }
  }
}
</script>
<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon :color="color" dark v-bind="attrs" v-on="on">
          {{ icon }}
        </v-icon>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
  </div>
</template>
